import { EServiceId } from '../../../../../../../../../../types/reducers/publishTerms';
import * as React from 'react';
import { IServiceComponentProps } from './types';
import { TopService } from '../TopService';
import { StandardService } from '../StandardService';
import { PremiumService } from '../PremiumService';

export type TServiceToComponentMap = {
  [serviceId in EServiceId]: React.FunctionComponent<IServiceComponentProps>;
};

export const serviceIdMapToComponent: TServiceToComponentMap = {
  [EServiceId.top]: TopService,
  [EServiceId.paid]: StandardService,
  [EServiceId.free]: StandardService,
  [EServiceId.premium]: PremiumService,
};
